import { othersTechnologies } from './othersTechnologies';
import { banner } from './banner';
import { technologyCta } from './technologiesCta';

export const technologies = { banner, othersTechnologies, technologyCta };
